<script lang="ts">
	import { goto } from '$app/navigation';
	import { page } from '$app/state';
	import Gtm from '$lib/component/analytics/Gtm.svelte';
	import ChatSupport from '$lib/component/navigation/ChatSupport.svelte';
	import { apiStore, initPublicApi } from '$lib/stores/api';
	import { businessTimezone, t } from '$lib/stores/i18n';
	import Loading from '$lib/svg/loading.svg.svelte';
	import WidgetDecorator from '$lib/widget/components/WidgetDecorator.svelte';
	import { widgetSetFlow } from '$lib/widget/flow';
	import { widgetChatEnabled, widgetConfig, widgetContent } from '$lib/widget/stores';
	import { onMount } from 'svelte';
	import type { PageData } from './$types';

	interface Props {
		data: PageData;
		children?: import('svelte').Snippet;
	}

	let { data, children }: Props = $props();

	$widgetConfig = data.widgetConfig;
	$widgetContent = data.widgetContent;
	let contractIsActive = data.contractActive;
	widgetSetFlow(page.url.searchParams.get('flow') ?? data.widgetConfig.flowSelected);

	$businessTimezone = $widgetContent?.business?.timezone;

	onMount(() => {
		initPublicApi();
		if (!contractIsActive) {
			goto('/widget/' + $widgetConfig.hash + '/inactive');
			return;
		}
	});
</script>

<Gtm gtmId="GTM-W2CGSD4B" />

<title>{$t('widget-external.page_title', { businessName: $widgetContent.business.name })}</title>
<div
	id="app-layout"
	class="flex flex-1 h-[100dvh] fixed w-full overflow-hidden bg-widget-background text-widget-background-on
            dark:bg-widget-background-dark dark:text-widget-background-dark-on"
>
	<WidgetDecorator config={$widgetConfig}>
		{#if !$apiStore}
			<Loading className="flex-none p-5 mt-4 mx-auto" width="w-12" />
		{:else if contractIsActive || page.url.pathname === '/widget/' + $widgetConfig.hash + '/inactive'}
			<div>
				{@render children?.()}
			</div>
		{/if}
	</WidgetDecorator>
</div>
{#if $widgetChatEnabled}
	<ChatSupport />
{/if}
